import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {IonicModule} from '@ionic/angular';
import {DateSummaryFieldComponent} from "./date-summary-field.component";
import {DateLabelModule} from "../date-label/date-label.module";
import {SummaryFieldModule} from "../../summary-field/summary-field.module";

@NgModule({
    imports: [
        CommonModule,
        IonicModule,
        DateLabelModule,
        SummaryFieldModule,
    ],
    declarations: [
        DateSummaryFieldComponent,
    ],
    exports: [
        DateSummaryFieldComponent,
    ],
})
export class DateSummaryFieldModule {
}